import React from 'react';
import PropTypes from 'prop-types';
import { appTheme } from '../../../theme';
import styled from 'styled-components';
import { Container, DetailsTitle, PageHeader } from '../../common';
import PDFSettingsForm from './PDFSettingsForm';
import { pdfFields } from '../constants';

const Instructions = styled.p`
  padding: ${appTheme.spacing.default} 0;
`;

const ItalicText = styled.span`
  font-style: italic;
`;

function PDFSettingsPage({ onGeneratePdf }) {
  return (
    <Container>
      <PageHeader title="Download Care Information" />
      <Instructions>
        Customize which sections of information will be printed by
        selecting/deselecting the options below. <br />
        <ItalicText>
          Note: Sections without saved information will not be printed, even if
          they are selected.
        </ItalicText>
      </Instructions>
      <DetailsTitle>Customize printed information</DetailsTitle>
      <PDFSettingsForm onGeneratePdf={onGeneratePdf} pdfFields={pdfFields} />
    </Container>
  );
}

PDFSettingsPage.propTypes = {
  onGeneratePdf: PropTypes.func.isRequired,
};

export default PDFSettingsPage;



// WEBPACK FOOTER //
// ./src/modules/PDFSettingsPage/components/PDFSettingsPage.js